import { CRM_API, RequestHelper } from "utils";

const RUTA = "tenant";
export const TenantService = (() => {
    const listado = function (args) {
        return new Promise((res) => res(args)).then((params) => {
            return RequestHelper(CRM_API).get(`${RUTA}`, params);
        });
    };

    const exportar = function (args) {
        return new Promise((res) => res(args)).then((params) => {
            return RequestHelper(CRM_API).post(`${RUTA}/excel`, params, true);
        });
    };

    const reporte = function (args) {
        return new Promise((res) => res(args)).then((params) => {
            return RequestHelper(CRM_API).post(`${RUTA}/reporte`, params);
        });
    };

    const reporteText = function (args) {
        return new Promise((res) => res(args)).then((params) => {
            return RequestHelper(CRM_API).post(`${RUTA}/text/reporte`, params, true);
        });
    };

    return {
        listado,
        exportar,
        reporte,
        reporteText
    };
})();